import React from "react";

import {
    ContentState,
    convertFromRaw,
    convertToRaw,
    EditorState,
    Modifier,
    RichUtils,
    SelectionState
} from "draft-js";
import Editor from 'draft-js-plugins-editor';

import createEmojiPlugin from 'draft-js-emoji-plugin';
import createMentionPlugin  from 'draft-js-mention-plugin';

import "draft-js/dist/Draft.css";
import 'draft-js-emoji-plugin/lib/plugin.css';
import 'draft-js-mention-plugin/lib/plugin.css';
import 'draft-js-image-plugin/lib/plugin.css';

import isSoftNewlineEvent from "draft-js/lib/isSoftNewlineEvent";
import {getBlockStyle} from "./blockStyles/BlockStyleToolbar";
import {mediaBlockRenderer} from "./entities/mediaBlockRenderer";
import {Link} from "react-router-dom";
import createLink from "../../../libs/createLink";
import addCustomMentionPlugin from "./plugins/AddCustomMention";
import Avatar from "../Avatar";
import _ from "lodash";


const customSuggestionsFilter = (searchValue, suggestions) => {
    const size = (list) => (list.constructor.name === 'List'
        ? list.size
        : list.length);

    const get = (obj, attr) => (obj.get
        ? obj.get(attr)
        : obj[attr]);

    const value = searchValue.toLowerCase();
    const filteredSuggestions = suggestions.filter((suggestion) => (
        !value || get(suggestion, 'username').toLowerCase().indexOf(value) > -1
    ));
    const length = size(filteredSuggestions) < 2 ? size(filteredSuggestions) : 1;
    return filteredSuggestions.slice(0, length);
};

const Entry = (props) => {
    const {
        mention,
        theme,
        searchValue,
        isFocused,
        ...parentProps
    } = props;

    return (
        <div {...parentProps} key={`empty_${mention._id}`}>
            <div className={"mentionSuggestionsEntryContainer"}>
                <div className={"mentionSuggestionsEntryContainerLeft"}>
                    <Avatar gender={mention.profile.gender} avatar={mention.profile.avatar} />
                </div>

                <div className={"mentionSuggestionsEntryContainerRight"}>
                    <div className={"mentionSuggestionsEntryText"}>
                        {mention.username}
                    </div>
                </div>
            </div>
        </div>
    );
};


class SimpleEditor extends React.Component {
    constructor(props) {
        super(props);
        const newEditorState = this.props.defaultValue ? EditorState.createWithContent(convertFromRaw(this.props.defaultValue)) : EditorState.createEmpty();
        this.mentionPlugin = createMentionPlugin({
            mentionComponent: (mentionProps) => (
                <Link key={mentionProps.mention._id} to={createLink('userProfile', mentionProps.mention)} target={"_blank"} rel="noopener noreferrer" className={"mentionned-name"}>
                    @{mentionProps.mention.username}
                </Link>
            ),
            mentionPrefix: "@",
            theme : {
                mentionSuggestions : "mentionSuggestions",
                mentionSuggestionsEntry: "mentionSuggestionsEntry",
                mentionSuggestionsEntryFocused: "mentionSuggestionsEntryFocused",
                mentionSuggestionsEntryText: "mentionSuggestionsEntryText",
                mentionSuggestionsEntryAvatar: "mentionSuggestionsEntryAvatar"
            }
        });

        this.emojiPlugin = createEmojiPlugin({
            useNativeArt: true,
            theme : {
                emoji: "emoji",
                emojiSuggestions: "emojiSuggestions",
                emojiSuggestionsEntry: "emojiSuggestionsEntry",
                emojiSuggestionsEntryFocused: "emojiSuggestionsEntryFocused",
                emojiSuggestionsEntryText: "emojiSuggestionsEntryText",
                emojiSuggestionsEntryIcon: "emojiSuggestionsEntryIcon",
                emojiSelect: "emojiSelect",
                emojiSelectButton: "emojiSelectButton",
                emojiSelectButtonPressed: "emojiSelectButtonPressed",
                emojiSelectPopover:"emojiSelectPopover",
                emojiSelectPopoverClosed:"emojiSelectPopoverClosed",
                emojiSelectPopoverTitle:"emojiSelectPopoverTitle",
                emojiSelectPopoverGroups:"emojiSelectPopoverGroups",
                emojiSelectPopoverGroup:"emojiSelectPopoverGroup",
                emojiSelectPopoverGroupTitle:"emojiSelectPopoverGroupTitle",
                emojiSelectPopoverGroupList:"emojiSelectPopoverGroupList",
                emojiSelectPopoverGroupItem:"emojiSelectPopoverGroupItem",
                emojiSelectPopoverToneSelect:"emojiSelectPopoverToneSelect",
                emojiSelectPopoverToneSelectList:"emojiSelectPopoverToneSelectList",
                emojiSelectPopoverToneSelectItem:"emojiSelectPopoverToneSelectItem",
                emojiSelectPopoverEntry:"emojiSelectPopoverEntry",
                emojiSelectPopoverEntryFocused:"emojiSelectPopoverEntryFocused",
                emojiSelectPopoverEntryIcon:"emojiSelectPopoverEntryIcon",
                emojiSelectPopoverNav:"emojiSelectPopoverNav",
                emojiSelectPopoverNavItem:"emojiSelectPopoverNavItem",
                emojiSelectPopoverNavEntry:"emojiSelectPopoverNavEntry",
                emojiSelectPopoverNavEntryActive:"emojiSelectPopoverNavEntryActive",
                emojiSelectPopoverScrollbar:"emojiSelectPopoverScrollbar",
                emojiSelectPopoverScrollbarThumb:"emojiSelectPopoverScrollbarThumb"
            }
        });
        this.state = {
            editorState: newEditorState,
            suggestions: [],
            mentions: [],
            isMention : false
        };
        this.handleKeyCommand = this.handleKeyCommand.bind(this);
    }


    componentDidMount() {
        if(this.props.subCommentAnswer && this.props.subCommentAnswer.owner && this.props.subCommentAnswer.owner._id) {
            //delay so decorator can render
            setTimeout(() => this.addMentionnedUser(this.props.subCommentAnswer.owner), 1);
        }
        if(this.props.userFriends){
            this.setState({mentions : this.props.userFriends});
        }
    }

    componentDidUpdate(prevProps){
        if((prevProps.subCommentAnswer && prevProps.subCommentAnswer.commentId !== this.props.subCommentAnswer.commentId) && this.props.subCommentAnswer.owner._id) {
            //clear currentContent of the comment and delay function so it works
            setTimeout(() => this.handleClear(), 1);
            //if commentId different add new owner of comment to answer
            setTimeout(() => this.addMentionnedUser(this.props.subCommentAnswer.owner), 2);
        }
        if(prevProps.userFriends !== this.props.userFriends){
            this.setState({mentions : this.props.userFriends});
        }
    }


    onChange(editorState) {
        let isMention = this.hasCustomMention();
        if(this.state.isMention !== isMention){
            if(typeof this.props.resetSubCommentAnswer === "function" && !isMention){
                this.props.resetSubCommentAnswer();
            }
        }
        this.setState({editorState, isMention}, ()=>this.props.onChange(this.getRaw()));
    };

    getRaw() {
        const content = this.state.editorState.getCurrentContent();
        return convertToRaw(content);
    }

    focus = () => this.refs ? this.refs.editor.focus() : null;
    // blur = () => this.refs.editor.blur();
    onFocus = () => {
         if(typeof this.props.onFocus === "function"){
             this.props.onFocus();
         }
    };
    onBlur = () => {
        if(typeof this.props.onBlur === "function"){
            this.props.onBlur();
        }
    };



    handleKeyCommand(command) {
        const newState = RichUtils.handleKeyCommand(
            this.state.editorState,
            command
        );
        if(command === "split-block" && typeof this.props.handleReturn === "function"){
            this.props.handleReturn();
                setTimeout(() => {
                    if(this.refs && this.refs.editor && typeof (this.refs.editor.blur) === 'function') {
                        this.refs.editor.blur()
                    }
                }, 1);



            // this.handleClear();
            // this.props.onChange(this.getRaw());
            return "handled";
        }
        // if(command === "backspace" && this.state.isMention !== this.hasCustomMention()){
        //     console.log("ok");
        //     // this.onChange(newState);
        //     this.setState({isMention : false});
        // }
        if (newState) {
            this.onChange(newState);
            return "handled";
        }

        return "not-handled";
    };

    handleReturn(event) {
        // if(typeof this.props.handleReturn === "function"){
        //     this.props.handleReturn();
        // }
        // else
            if (isSoftNewlineEvent(event)) {
            this.onChange(RichUtils.insertSoftNewline(this.state.editorState));
            return 'handled';
        }
        return 'not-handled';
    }

    onSearchChange = ({ value }) => {
        this.setState({
            suggestions: customSuggestionsFilter(value, this.state.mentions),
        });
    };

    handleClear(){
        const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''));
        this.setState({ editorState });
    }

    handleHasText(){
        return this.state.editorState.getCurrentContent().hasText();
    }

    hasCustomMention(){
        const editorState = this.state.editorState;
        const contentState = editorState.getCurrentContent();
        const raw = convertToRaw(contentState);
        const hasCustomMention = raw.entityMap ? _.values(raw.entityMap).filter(item => item.type === "CUSTOM_MENTION") : [];
        return hasCustomMention.length >= 1;
    }

    addMentionnedUser(mention){
        const editorState = this.state.editorState;
        const contentState = editorState.getCurrentContent();
        const selection = editorState.getSelection();
        const textWithSpace = mention.username.concat(' ');

        // create new content with text
        const newContent = Modifier.insertText(
            contentState,
            selection,
            textWithSpace,
        );
        // create new link entity
        const newContentWithEntity = newContent.createEntity(
            "CUSTOM_MENTION",
            'SEGMENTED',
            {mention}
        );
        const entityKey = newContentWithEntity.getLastCreatedEntityKey();
        // create new selection with the inserted text
        const anchorOffset = selection.getAnchorOffset();
        const newSelection = new SelectionState({
            anchorKey: selection.getAnchorKey(),
            anchorOffset,
            focusKey: selection.getAnchorKey(),
            focusOffset: anchorOffset + mention.username.length,
        });
        // and aply link entity to the inserted text
        const newContentWithLink = Modifier.applyEntity(
            newContentWithEntity,
            newSelection,
            entityKey,
        );
        // create new state with link text
        const withLinkText = EditorState.push(
            editorState,
            newContentWithLink,
            'insert-characters',
        );

        // now lets add cursor right after the inserted link
        const newEditorState = EditorState.forceSelection(
            withLinkText,
            newContent.getSelectionAfter(),
        );
        // update the editor with all changes
        this.onChange(newEditorState);
        // this.setState({isMention : true});
    };

    render() {

        const { MentionSuggestions } = this.mentionPlugin;
        const { EmojiSelect } = this.emojiPlugin;
        const plugins = [
            this.emojiPlugin,
            addCustomMentionPlugin,
            this.mentionPlugin
        ];

        return (
            <div className={"column full"}>
                <MentionSuggestions
                    onSearchChange={this.onSearchChange}
                    suggestions={this.state.suggestions}
                    entryComponent={Entry}
                />
                <div className={`mk-editor simple-display ${this.props.editorStyle || ""}`} >
                    <Editor
                        blockRendererFn={mediaBlockRenderer}
                        ref="editor"
                        spellCheck
                        onFocus={()=>this.onFocus()} // * never invoked
                        onBlur={()=>this.onBlur()}
                        blockStyleFn={getBlockStyle}
                        editorState={this.state.editorState}
                        plugins={plugins}
                        placeholder={this.props.placeholder || ""}
                        handleKeyCommand={this.handleKeyCommand.bind(this)}
                        onChange={this.onChange.bind(this)}
                        handleReturn={this.handleReturn.bind(this)}
                    />

                    <EmojiSelect   />
                </div>
            </div>
        );
    }
}

export default SimpleEditor;